export default "__VITE_ASSET__Crz6bGU3__"